import Vue from 'vue'
import Vuex from 'vuex'

import home from './home'
import common from './common'
import messages from './messages'
import banners from './banners'
import oferte from './oferte'
import orders from './orders'
import searches from './searches'
import searchips from './searchips'
import searchlimits from './searchlimits'
import banlists from './banlists'
import disconnects from './disconnects'
import banlistpgs from './banlistpgs'
import bans from './bans'
import oferteconfirm from './oferteconfirm'
import surveys from './surveys'
import cachearticles from './cachearticles'
import cachefilters from './cachefilters'
import cacheaccess from './cacheaccess'
import cachepieseschimb from './cachepieseschimb'
import cachesearches from './cachesearches'
import pagecontact from './pagecontact'
import pageinfo from './pageinfo'
import pagedownloads from './pagedownloads'
import pageutile from './pageutile'
import bateriiuzate from './bateriiuzate'
import user from './user'
import users from './users'
import roles from './roles'
import apiusers from './apiusers'

Vue.use(Vuex)

export default function () {
  const Store = new Vuex.Store({
    modules: {
      home,
      common,
      messages,
      banners,
      oferte,
      orders,
      searches,
      searchips,
      searchlimits,
      banlists,
      disconnects,
      banlistpgs,
      bans,
      oferteconfirm,
      surveys,
      cachearticles,
      cachefilters,
      cacheaccess,
      cachepieseschimb,
      cachesearches,
      pagecontact,
      pageinfo,
      pagedownloads,
      pageutile,
      bateriiuzate,
      user,
      users,
      roles,
      apiusers
    }
  })

  return Store
}
